import React, {Component} from 'react';
import './Dice.css';
import { getRandomInt } from './util';

class EoTDie extends Component {
  roll() {
    return this.constructor.options[getRandomInt(0, this.constructor.options.length-1)];
  }

  render() {
    return (
      <div className="dice_eot_die">
        <img
          src={`/diceImages/eot/${this.constructor.type}.png`}
          alt={this.constructor.type} width="30"
        />
      </div>
    )
  }
}

/* Dice symbol key:
 * (S)uccess, (A)dvantage, (F)ailure), (T)hreat,
 * t(R)iumph, (D)espair    (W)hite,    (B)lack
 * */

export class EoTAbility extends EoTDie {
  static type = 'ability';
  static options = ['', 'S', 'S', 'SS', 'A', 'A', 'SA', 'AA'];
}
export class EoTAdvantage extends EoTDie {
  static type = 'advantage';
  static options = ['A'];
}
export class EoTBlack extends EoTDie {
  static type = 'black';
  static options = ['B'];
}
export class EoTBoost extends EoTDie {
  static type = 'boost';
  static options = ['', '', 'S', 'SA', 'AA', 'A'];
}
export class EoTChallenge extends EoTDie {
  static type = 'challenge';
  static options = ['', 'F', 'F', 'FF', 'FF', 'T', 'T', 'FT', 'FT', 'TT', 'TT', 'D'];
}
export class EoTDespair extends EoTDie {
  static type = 'despair';
  static options = ['D'];
}
export class EoTDifficulty extends EoTDie {
  static type = 'difficulty';
  static options = ['', 'F', 'FF', 'T', 'T', 'T', 'TT', 'FT'];
}
export class EoTFail extends EoTDie {
  static type = 'fail';
  static options = ['F'];
}
export class EoTForce extends EoTDie {
  static type = 'force';
  static options = ['WW', 'WW', 'WW', 'W', 'W', 'BB', 'B', 'B', 'B', 'B', 'B', 'B'];
}
export class EoTProficiency extends EoTDie {
  static type = 'proficiency';
  static options = ['', 'S', 'S', 'SS', 'SS', 'A', 'SA', 'SA', 'SA', 'AA', 'AA', 'R'];
}
export class EoTSetback extends EoTDie {
  static type = 'setback';
  static options = ['', '', 'F', 'F', 'T', 'T'];
}
export class EoTSuccess extends EoTDie {
  static type = 'success';
  static options = ['S'];
}
export class EoTThreat extends EoTDie {
  static type = 'threat';
  static options = ['T'];
}
export class EoTTriumph extends EoTDie {
  static type = 'triumph';
  static options = ['R'];
}
export class EoTWhite extends EoTDie {
  static type = 'white';
  static options = ['W'];
}



// WEBPACK FOOTER //
// ./src/Dice/EoTDie.js